import React, { JSX } from 'react';
import Keys from '../../../_Translations/generated/notes-formatter.en.t.json.keys';
import fallback from '../../../_Translations/generated/notes-formatter.en.t.json';
import useTranslation from '../../Hooks/useTranslation';

export interface Props {
  notes: string[];
}

const NotesFormatter = (props: Props): JSX.Element => {
  const { notes } = props;
  const { t } = useTranslation('notes-formatter', fallback, Keys);

  const terms = notes.map((term): string[] => {
    return term.split(/\r?\n/);
  });

  const items = terms.reduce((a, b) => a.concat(b), []);

  function isOneOfTitle(note: string): boolean {
    switch (note) {
      case t(Keys.subItemType_HOTEL):
      case t(Keys.subItemType_TOUR):
      case t(Keys.subItemType_FLIGHT):
      case t(Keys.subItemType_EXTRA):
      case t(Keys.subItemType_CHAUFFEURED_SERVICE):
      case t(Keys.subItemType_TRANSFER):
      case t(Keys.subItemType_AIRPORT_TRANSFER):
      case t(Keys.subItemType_DINING):
      case t(Keys.subItemType_LOUNGE_ACCESS):
      case t(Keys.subItemType_MEET_AND_GREET):
      case t(Keys.subItemType_PACKAGE):
        return true;
      default:
        return false;
    }
  }

  return (
    <div>
      {notes &&
        items.map(item => {
          return (
            <div className={`pb-3 tab-notes ${isOneOfTitle(item) ? 'font-weight-bold' : ''}`}>
              {item}
            </div>
          );
        })}
    </div>
  );
};

export default NotesFormatter;
